export const DETALHE_EVENTO_PJ = [
  {
    "evento": {
      "codigo": "101",
      "descricao": "Inscrição de primeiro estabelecimento"
    },
    "dataEvento": [
      1997,
      7,
      25
    ],
    "horaDigitacao": "1048220",
    "dataDigitacao": [
      1997,
      8,
      15
    ],
    "dataProcessamento": [
      1997,
      8,
      15
    ],
    "horaProcessamento": "01127461",
    "recibo": "",
    "terminal": "KAS01603",
    "cpfDigitador": "03521609855",
    "cpfTransmissor": null,
    "cpfConferente": "01268459801",
    "orgaoOrigem": "0810100"
  },
  {
    "evento": {
      "codigo": "202",
      "descricao": "Alteração da pessoa física responsável perante o CNPJ"
    },
    "dataEvento": [
      1998,
      6,
      9
    ],
    "horaDigitacao": "1023220",
    "dataDigitacao": [
      1998,
      9,
      4
    ],
    "dataProcessamento": [
      1998,
      9,
      10
    ],
    "horaProcessamento": "01223342",
    "recibo": "",
    "terminal": "0011571",
    "cpfDigitador": null,
    "cpfTransmissor": "01685862829",
    "cpfConferente": "01685862829",
    "orgaoOrigem": "0812100"
  },
  {
    "evento": {
      "codigo": "211",
      "descricao": "Alteração de endereço dentro do mesmo município"
    },
    "dataEvento": [
      1998,
      7,
      17
    ],
    "horaDigitacao": "1023220",
    "dataDigitacao": [
      1998,
      9,
      4
    ],
    "dataProcessamento": [
      1998,
      9,
      10
    ],
    "horaProcessamento": "01223342",
    "recibo": "",
    "terminal": "0011571",
    "cpfDigitador": null,
    "cpfTransmissor": "01685862829",
    "cpfConferente": "01685862829",
    "orgaoOrigem": "0812100"
  },
  {
    "evento": {
      "codigo": "202",
      "descricao": "Alteração da pessoa física responsável perante o CNPJ"
    },
    "dataEvento": [
      1999,
      2,
      8
    ],
    "horaDigitacao": "1533200",
    "dataDigitacao": [
      1999,
      4,
      8
    ],
    "dataProcessamento": [
      1999,
      4,
      9
    ],
    "horaProcessamento": "01421238",
    "recibo": "",
    "terminal": "0040775",
    "cpfDigitador": null,
    "cpfTransmissor": "16292290832",
    "cpfConferente": "07313392826",
    "orgaoOrigem": "0812100"
  },
  {
    "evento": {
      "codigo": "228",
      "descricao": "Alteração do código da atividade econômica principal"
    },
    "dataEvento": [
      1999,
      2,
      8
    ],
    "horaDigitacao": "623000",
    "dataDigitacao": [
      1999,
      4,
      15
    ],
    "dataProcessamento": [
      1999,
      4,
      16
    ],
    "horaProcessamento": "01017254",
    "recibo": "",
    "terminal": "0019328",
    "cpfDigitador": null,
    "cpfTransmissor": "11648048803",
    "cpfConferente": "06579709804",
    "orgaoOrigem": "0812100"
  },
  {
    "evento": {
      "codigo": "209",
      "descricao": "Alteração de endereço entre municípios dentro do mesmo estado"
    },
    "dataEvento": [
      1999,
      5,
      25
    ],
    "horaDigitacao": "1500050",
    "dataDigitacao": [
      1999,
      6,
      11
    ],
    "dataProcessamento": [
      1999,
      6,
      17
    ],
    "horaProcessamento": "01538443",
    "recibo": "",
    "terminal": "0065298",
    "cpfDigitador": null,
    "cpfTransmissor": "00041868854",
    "cpfConferente": "00041868854",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "228",
      "descricao": "Alteração do código da atividade econômica principal"
    },
    "dataEvento": [
      1999,
      5,
      25
    ],
    "horaDigitacao": "1500050",
    "dataDigitacao": [
      1999,
      6,
      11
    ],
    "dataProcessamento": [
      1999,
      6,
      17
    ],
    "horaProcessamento": "01538443",
    "recibo": "",
    "terminal": "0065298",
    "cpfDigitador": null,
    "cpfTransmissor": "00041868854",
    "cpfConferente": "00041868854",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "936",
      "descricao": "Alteração do Endereço para DIPJ"
    },
    "dataEvento": [
      1999,
      8,
      13
    ],
    "horaDigitacao": "232123",
    "dataDigitacao": [
      2000,
      12,
      14
    ],
    "dataProcessamento": [
      2000,
      12,
      14
    ],
    "horaProcessamento": "00232123",
    "recibo": "",
    "terminal": "N03218RO",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "cpfConferente": "00000000191",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "211",
      "descricao": "Alteração de endereço dentro do mesmo município"
    },
    "dataEvento": [
      2000,
      11,
      30
    ],
    "horaDigitacao": "814410",
    "dataDigitacao": [
      2000,
      12,
      19
    ],
    "dataProcessamento": [
      2000,
      12,
      19
    ],
    "horaProcessamento": "01615370",
    "recibo": "",
    "terminal": "0037108",
    "cpfDigitador": null,
    "cpfTransmissor": "86764012849",
    "cpfConferente": "86764012849",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "202",
      "descricao": "Alteração da pessoa física responsável perante o CNPJ"
    },
    "dataEvento": [
      2000,
      11,
      30
    ],
    "horaDigitacao": "814410",
    "dataDigitacao": [
      2000,
      12,
      19
    ],
    "dataProcessamento": [
      2000,
      12,
      19
    ],
    "horaProcessamento": "01615370",
    "recibo": "",
    "terminal": "0037108",
    "cpfDigitador": null,
    "cpfTransmissor": "86764012849",
    "cpfConferente": "86764012849",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "209",
      "descricao": "Alteração de endereço entre municípios dentro do mesmo estado"
    },
    "dataEvento": [
      2003,
      3,
      12
    ],
    "horaDigitacao": "937080",
    "dataDigitacao": [
      2003,
      4,
      4
    ],
    "dataProcessamento": [
      2003,
      4,
      7
    ],
    "horaProcessamento": "00847358",
    "recibo": "",
    "terminal": "INTERNET",
    "cpfDigitador": null,
    "cpfTransmissor": "12069548848",
    "cpfConferente": "12069548848",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "221",
      "descricao": "Alteração do título do estabelecimento (nome de fantasia)"
    },
    "dataEvento": [
      2003,
      3,
      12
    ],
    "horaDigitacao": "937080",
    "dataDigitacao": [
      2003,
      4,
      4
    ],
    "dataProcessamento": [
      2003,
      4,
      7
    ],
    "horaProcessamento": "00847358",
    "recibo": "",
    "terminal": "INTERNET",
    "cpfDigitador": null,
    "cpfTransmissor": "12069548848",
    "cpfConferente": "12069548848",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "228",
      "descricao": "Alteração do código da atividade econômica principal"
    },
    "dataEvento": [
      2003,
      3,
      12
    ],
    "horaDigitacao": "937080",
    "dataDigitacao": [
      2003,
      4,
      4
    ],
    "dataProcessamento": [
      2003,
      4,
      7
    ],
    "horaProcessamento": "00847358",
    "recibo": "",
    "terminal": "INTERNET",
    "cpfDigitador": null,
    "cpfTransmissor": "12069548848",
    "cpfConferente": "12069548848",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "202",
      "descricao": "Alteração da pessoa física responsável perante o CNPJ"
    },
    "dataEvento": [
      2006,
      3,
      31
    ],
    "horaDigitacao": "1535080",
    "dataDigitacao": [
      2006,
      9,
      4
    ],
    "dataProcessamento": [
      2006,
      9,
      12
    ],
    "horaProcessamento": "01533319",
    "recibo": "",
    "terminal": "INTERNET",
    "cpfDigitador": null,
    "cpfTransmissor": "00041868854",
    "cpfConferente": "00041868854",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "202",
      "descricao": "Alteração da pessoa física responsável perante o CNPJ"
    },
    "dataEvento": [
      2008,
      5,
      5
    ],
    "horaDigitacao": "1621460",
    "dataDigitacao": [
      2008,
      5,
      5
    ],
    "dataProcessamento": [
      2008,
      5,
      19
    ],
    "horaProcessamento": "01608369",
    "recibo": "",
    "terminal": "INTERNET",
    "cpfDigitador": null,
    "cpfTransmissor": "00041868854",
    "cpfConferente": "00041868854",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "211",
      "descricao": "Alteração de endereço dentro do mesmo município"
    },
    "dataEvento": [
      2010,
      1,
      27
    ],
    "horaDigitacao": "1200470",
    "dataDigitacao": [
      2010,
      3,
      15
    ],
    "dataProcessamento": [
      2010,
      3,
      25
    ],
    "horaProcessamento": "01641240",
    "recibo": "3340287127",
    "terminal": "INTERNET",
    "cpfDigitador": null,
    "cpfTransmissor": "00000000191",
    "cpfConferente": "00000000191",
    "orgaoOrigem": "9999999"
  },
  {
    "evento": {
      "codigo": "248",
      "descricao": "Alteração do tipo de unidade"
    },
    "dataEvento": [
      2010,
      1,
      27
    ],
    "horaDigitacao": "1200470",
    "dataDigitacao": [
      2010,
      3,
      15
    ],
    "dataProcessamento": [
      2010,
      3,
      25
    ],
    "horaProcessamento": "01641240",
    "recibo": "3340287127",
    "terminal": "INTERNET",
    "cpfDigitador": null,
    "cpfTransmissor": "00000000191",
    "cpfConferente": "00000000191",
    "orgaoOrigem": "9999999"
  },
  {
    "evento": {
      "codigo": "912",
      "descricao": "Suspensão - Baixa Recepcionada (Em Análise)"
    },
    "dataEvento": [
      2010,
      10,
      19
    ],
    "horaDigitacao": "1205060",
    "dataDigitacao": [
      2010,
      10,
      19
    ],
    "dataProcessamento": [
      2010,
      10,
      19
    ],
    "horaProcessamento": "01205171",
    "recibo": "3796337799",
    "terminal": "00006986",
    "cpfDigitador": "15216904808",
    "cpfTransmissor": "15216904808",
    "cpfConferente": "15216904808",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "517",
      "descricao": "Pedido de baixa"
    },
    "dataEvento": [
      2010,
      8,
      27
    ],
    "horaDigitacao": "1633130",
    "dataDigitacao": [
      2010,
      10,
      7
    ],
    "dataProcessamento": [
      2010,
      10,
      22
    ],
    "horaProcessamento": "01827406",
    "recibo": "3796337799",
    "terminal": "INTERNET",
    "cpfDigitador": null,
    "cpfTransmissor": "00000000191",
    "cpfConferente": "00000000191",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "719",
      "descricao": "Alteração da data de primeiro vínculo"
    },
    "dataEvento": [
      1997,
      7,
      25
    ],
    "horaDigitacao": "45480",
    "dataDigitacao": [
      2012,
      4,
      27
    ],
    "dataProcessamento": [
      2012,
      4,
      27
    ],
    "horaProcessamento": "00045480",
    "recibo": "",
    "terminal": "COCAD 150/2010",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "cpfConferente": "00000000191",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "720",
      "descricao": "Alteração de CNAE de Estudo"
    },
    "dataEvento": [
      2013,
      6,
      10
    ],
    "horaDigitacao": "1949162",
    "dataDigitacao": [
      2013,
      6,
      10
    ],
    "dataProcessamento": [
      2013,
      6,
      10
    ],
    "horaProcessamento": "01949162",
    "recibo": "",
    "terminal": "K032007Z",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "cpfConferente": "00000000191",
    "orgaoOrigem": "0812400"
  },
  {
    "evento": {
      "codigo": "719",
      "descricao": "Alteração da data de primeiro vínculo"
    },
    "dataEvento": [
      1997,
      1,
      1
    ],
    "horaDigitacao": "521334",
    "dataDigitacao": [
      2014,
      5,
      13
    ],
    "dataProcessamento": [
      2014,
      5,
      13
    ],
    "horaProcessamento": "00521334",
    "recibo": "",
    "terminal": "K032004T",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "cpfConferente": "00000000191",
    "orgaoOrigem": "0812400"
  }
];